// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { commonShortFieldLabels } from "./common-short-fields";
import { platformAdminAssetsObjectSpaces } from "./platform-admin-assets-object-spaces";

export const platformAdminAssetsManagement = {
  columns: {
    filename: "ファイル名",
    assetId: "アセット ID",
    objectSpace: "オブジェクト空間",
    storage: "ストレージ",
    size: "サイズ",
    references: "参照数",
    createdAt: commonShortFieldLabels.createdAt,
    actions: "操作",
    owner: "所有者",
    ownerSubject: "帰属主体",
    uploader: "アップロード者",
    inUse: "使用中",
    service: "サービス",
    scope: "スコープ",
    resourceType: "リソース種別",
    resourceId: "リソース ID",
    field: "フィールド",
    label: "説明",
    businessService: "業務サービス",
    bindingCount: "紐付数",
    assetCountRef: "関連アセット数",
    note: "備考",
    shareMode: "共有方式",
    shareState: "共有状態",
    ...platformAdminAssetsObjectSpaces.columns,
  },
  actions: {
    governanceDetail: "統治詳細",
    share: "共有",
    clone: "自分の資産へ複製",
    uploadToMySpace: "ファイルをアップロード",
    viewMySpacePolicy: "空間ポリシー / 容量上限を表示",
    copyDownloadLink: "ダウンロードリンクをコピー",
    editNote: "備考を編集",
    shareToPublic: "公開へ共有",
    cancelPublicShare: "共有を取り消す",
    copyToMySpaceRecommended: "マイスペースへコピー（推奨）",
    ...platformAdminAssetsObjectSpaces.actions,
  },
  drawer: {
    referenceBindingCatalogDetail: "バインド詳細 · {service} / {scope} / {resourceType}",
    referenceAssetCatalogDetail: "関連アセット · {service} / {scope} / {resourceType}",
    ...platformAdminAssetsObjectSpaces.drawer,
  },
  fields: {
    note: "備考",
    ...platformAdminAssetsObjectSpaces.fields,
  },
  form: {
    removeAssetTitle: "ファイルを削除",
    removeAssetDescription: "{name} を削除しますか？参照中アセットは削除できません。",
    assetNoteTitle: "備考を編集 · {name}",
    assetNoteTitleShort: "備考を編集",
    noSelectedAsset: "ファイルが選択されていません",
    note: "備考",
    sharePublicTitle: "公開へ共有",
    sharePublicDescription:
      "{name} を公開共有ディレクトリへ共有しますか？共有後も所有者は現在のユーザーのままです。",
    unsharePublicTitle: "共有を取り消す",
    unsharePublicDescription:
      "{name} の公開共有を取り消しますか？このアセットが他のモジュールから参照されている場合、操作は阻止されます。",
    ...platformAdminAssetsObjectSpaces.form,
  },
  errors: {
    loadFailed: "アセットセンターデータの読取に失敗しました",
    mySpaceLoadFailed: "マイスペースの読取に失敗しました",
    mySpaceUploadFailed: "マイスペースへのアップロードに失敗しました",
    mySpaceDeleteFailed: "マイスペースのファイル削除に失敗しました",
    mySpaceNoteUpdateFailed: "ファイル備考の更新に失敗しました",
    publicBrandingLoadFailed: "公開ブランド資源ディレクトリの読取に失敗しました",
    publicBrandingDeleteFailed: "公開ブランド資源ディレクトリのファイル削除に失敗しました",
    publicBrandingNoteUpdateFailed: "公開ブランド資源ディレクトリの備考更新に失敗しました",
    sharePublicFailed: "公開への共有に失敗しました",
    unsharePublicFailed: "共有の取り消しに失敗しました",
    copyToMySpaceFailed: "マイスペースへのコピーに失敗しました",
    cloneFailed: "アセットの複製に失敗しました",
    uploadRequestIncomplete: "アップロード要求の応答が不完全です",
    uploadCompleteMissingAsset: "アップロード完了後に asset_id が返ってきませんでした",
    governanceDetailLoadFailed: "アセット統治詳細の読取に失敗しました",
    ...platformAdminAssetsObjectSpaces.errors,
  },
  messages: {
    sharePublicSuccess: "{name} を公開ディレクトリへ共有しました",
    unsharePublicSuccess: "{name} の公開共有を取り消しました",
    copyToMySpaceSuccess: "{name} をマイスペースへコピーしました",
    cloneSuccess: "アセットを自分の資産へ複製しました",
  },
  objects: {
    ...platformAdminAssetsObjectSpaces.objects,
  },
} as const;
